export default "__VITE_ASSET__D7ULFP5t__"